import Button from '../Button.js';
import Icon from '../Icon.js';
import StepFrame from './StepFrame.js';
import Theme from '../styles/Theme.js';
import Utils from '../Utils.js';

/*
 * HandoffStep
 *
 * The end of Applied Fire's job. The customer did not know which system they
 * owned; the questions worked it out; this hands them to that brand's tree with
 * everything they have already said.
 *
 * It CONFIRMS rather than redirecting silently. Identifying the product is the
 * one thing the router exists to do, and doing it invisibly gives the customer
 * no chance to say "no, that is not mine" before they are five questions into
 * the wrong brand. Back still works, so the correction costs one tap.
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const HandoffStep = ({
  node,
  onHandoff,
  stepKey,
  target
}) => {
  const mobile = Utils.isMobile();
  return /*#__PURE__*/_jsx(StepFrame, {
    actions: /*#__PURE__*/_jsx(Button, {
      icon: 'arrow-right',
      label: `Continue to ${target?.name || 'support'}`,
      onClick: onHandoff.bind(this, node.brand)
    }),
    eyebrow: 'Identified',
    footnote: 'Wrong system? Go back and change your answer. Nothing is sent yet.',
    stepKey: stepKey,
    title: node.title || `That sounds like ${target?.name || 'another system'}`,
    children: /*#__PURE__*/_jsxs("div", {
      style: {
        alignItems: 'center',
        backgroundColor: Theme.colors.offWhite,
        border: `1px solid ${Theme.colors.border()}`,
        borderRadius: 14,
        display: 'flex',
        gap: 14,
        padding: mobile ? '18px 18px' : '20px 22px'
      },
      children: [/*#__PURE__*/_jsx("span", {
        style: {
          alignItems: 'center',
          backgroundColor: target?.accent || Theme.colors.primary(),
          borderRadius: 10,
          display: 'inline-flex',
          flexShrink: 0,
          height: 38,
          justifyContent: 'center',
          width: 38
        },
        children: /*#__PURE__*/_jsx(Icon, {
          color: '#FFFFFF',
          name: 'shield-check',
          size: 17
        })
      }), /*#__PURE__*/_jsxs("span", {
        children: [/*#__PURE__*/_jsx("span", {
          style: {
            ...Theme.textStyles.subHeading({
              fontSize: 16
            }),
            display: 'block'
          },
          children: target?.name || node.brand
        }), /*#__PURE__*/_jsx("span", {
          style: {
            ...Theme.textStyles.body({
              fontSize: 14
            }),
            display: 'block',
            marginTop: 3
          },
          children: node.summary || 'Your answers carry over, so you will not be asked any of this again.'
        })]
      })]
    })
  });
};
export default HandoffStep;